import { AppDispatch } from '@center-pwa/store/store';
import { emitEvent } from '@center-pwa/reducers/metaspaceEventsReducer';
import type { LegacyBridgeEventType, SpaceAction } from 'design-system/my-lib';

/**
 * Bridges a `space/v1` wire's `legacyEventType` onto the existing global `metaspaceEventsReducer`
 * bus, so legacy consumers (toolbar/chat) keep working unchanged when the triggering Section now
 * lives in the new Space renderer instead of a legacy `layout[]` organism (SC6).
 *
 * `useSpaceWires` (design-system, host-agnostic) only ever calls this with a value from the closed
 * `LEGACY_BRIDGE_EVENT_TYPES` set, so no further validation is needed here.
 */
export function createLegacyEventBridge(dispatch: AppDispatch, context: { sphereId?: string; metaspaceId?: string }) {
  return (eventType: LegacyBridgeEventType, action: SpaceAction) => {
    dispatch(
      emitEvent({
        type: eventType,
        payload: {
          // `action.context` is AUTHORED data — a composition can be published
          // cross-org and subscribed via a channel — so it is spread FIRST and the
          // host's values win. Spread last, a document could retarget the emitted
          // legacy event at a sphere/metaspace the host never sanctioned, and the
          // toolbar/chat consumers would act on it.
          ...action.context,
          sphereId: context.sphereId,
          metaspaceId: context.metaspaceId,
          timestamp: Date.now(),
        },
      })
    );
  };
}
